<template>
  <div class="topic-manager">
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-xl-6">课题管理员</div>
      <div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;">
        <Breadcrumb></Breadcrumb>
      </div>
    </div>
    <el-card>
			
      <template v-if="status==1">
        <el-table :header-cell-style="tableHeaderStyle" :data="list" border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="realName" label="姓名" min-width="90"></el-table-column>
          <el-table-column prop="username" label="用户名" min-width="90"></el-table-column>
          <el-table-column prop="unitName" label="单位" min-width="100"></el-table-column>
          <el-table-column prop="learningSections" label="负责学段" min-width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.learningSections && scope.row.learningSections.length>0">
                {{scope.row.learningSections | stageTextFilters}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="classNum" label="管理课题数量" min-width="90"></el-table-column>
          <el-table-column label="设置审核范围" min-width="90">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="handleStageChange(scope.row,scope.$index)">设置</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="btn-wrap">
          <el-button size="small" type="primary" class="mr-2" @click="addSubjectManager">添加</el-button>
          <el-popconfirm title="确定删除吗？" @confirm="delSubjectUser">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </div>
        <!-- 分页器 -->
        <div class="text-right mt-2">
          <el-pagination background layout="total, prev, pager, next" :page-size="query.pageSize" :total="total" @current-change="(e)=>{handlePageChange(e)}"></el-pagination>
        </div>
      </template>
			
      <template v-else>
        <div class="user-list">
          <el-page-header @back="toBack" content="设置课题管理员"></el-page-header>
          <div class="mt-2 mb-2">
            <span>姓名：</span>
            <el-input v-model="query.realName" placeholder="请输入" class="ml-3 mr-3" style="width: 180px" size="small"></el-input>
            <span>单位：</span>
            <el-input v-model="query.unitName" placeholder="请输入" class="ml-3 mr-3" style="width: 180px" size="small"></el-input>
            <el-button type="success" size="small" @click="searchUser">查询</el-button>
          </div>
          <!-- 表格 -->
          <el-table :header-cell-style="tableHeaderStyle" :data="list" border style="width: 100%" @selection-change="userSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="realName" label="姓名" width="180"></el-table-column>
            <el-table-column prop="unitName" label="单位" width="180"></el-table-column>
            <el-table-column prop="username" label="用户名"></el-table-column>
          </el-table>
        </div>
        <div class="mt-2">
          <el-button type="primary" size="small" @click="addSubjectUser">确 定</el-button>
        </div>
        <!-- 分页器 -->
        <div class="text-right mt-2">
          <el-pagination background layout="total, prev, pager, next" :page-size="query.pageSize" :total="total" @current-change="(e)=>{handlePageChange2(e)}"></el-pagination>
        </div>
      </template>
			
    </el-card>

    <!-- 系统用户的列表弹出框 -->
    <!-- <el-dialog title="添加课题管理员" :visible.sync="userListDialogVisible" width="70%" :close-on-click-modal="false">
      <div class="user-list">
        <el-form :model="queryUser" ref="userListForm" label-width="100px" class="demo-ruleForm">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="姓名" prop="realName">
                <el-input v-model="queryUser.realName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单位" prop="realName">
                <el-input v-model="queryUser.unitName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button @click="getUserList">查询</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-table :header-cell-style="tableHeaderStyle" :data="userList" border style="width: 100%" @selection-change="userSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="realName" label="姓名" width="180"></el-table-column>
          <el-table-column prop="unitName" label="单位" width="180"></el-table-column>
          <el-table-column prop="username" label="用户名"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userListDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="userListDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog> -->

    <!-- 设置学段对话框 -->
    <el-dialog title="设置初审员审核学段" :visible.sync="setAuditScopeDialogVisible" width="30%" :close-on-click-modal="false">
      <div class="audit-scope">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="stageSelectAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="stageUserData.learningSections">
          <el-checkbox v-for="item in stageOptions" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setAuditScopeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="stageSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/views/backstage/components/Breadcrumb.vue";
import {
  getSubjectUserList,
  updateRole,
  updateLearningSection,
} from "@/api/after/systemManagement";
export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      subjectId: "2",
      tableHeaderStyle: {
        backgroundColor: "#3083c5",
        color: "#fff",
      },
      status: 1,

      multipleSelection: [],
      userMultipleSelection: [],
      query: {
        realName: "",
        unitName: "",
        type: 1,
        pageNumber: 1,
        pageSize: 10,
        pageSorts: [{ asc: true, column: "" }],
      },
      list: [],
      total: 0,
      stageOptions: [
        { id: "0", name: "幼儿园" },
        { id: "1", name: "小学" },
        { id: "2", name: "初中" },
        { id: "3", name: "高中" },
        { id: "4", name: "中/高职" },
        { id: "5", name: "其他" },
      ],
      setAuditScopeDialogVisible: false,
      stageUserData: {}, //学段-正在被编辑的用户
      stageUserIndex: null, //学段-正在被编辑的用户列表第几项
      checkAll: false, //是否全选
      isIndeterminate: false, //全选按钮状态
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 获取数据列表
    getData(name) {
      getSubjectUserList(this.query).then((res) => {
        if (res.code == 200) {
          if (name == 2) {
            this.status = 2;
          } else {
            this.status = 1;
          }
          this.total = res.data.total;
          this.list = res.data.records;
        } else {
          this.$message.error(res.data);
        }
      });
    },

    // 设置学段
    handleStageChange(data, index) {
      this.stageUserData = JSON.parse(JSON.stringify(data));
      console.log("学段", this.stageUserData);
      this.stageUserIndex = index;
      if (
        this.stageUserData.learningSections &&
        this.stageUserData.learningSections.length > 0
      ) {
        this.isIndeterminate = true;
      } else {
        this.stageUserData.learningSections = [];
        this.isIndeterminate = false;
      }
      this.setAuditScopeDialogVisible = true;
    },
    stageSelectAllChange(val) {
      let arr = ["0", "1", "2", "3", "4", "5"];
      this.stageUserData.learningSections = val ? arr : [];
      this.isIndeterminate = false;
    },
    stageSubmit() {
      let learningSection = "";
      if (this.stageUserData.learningSections.length > 0) {
        learningSection = this.stageUserData.learningSections.join(",");
      }
      let query = {
        id: this.stageUserData.id,
        eduLearningSection: learningSection,
        roleId: "5",
      };
      this.updateLearningSection(query);
    },
    // 修改学段
    updateLearningSection(query) {
      updateLearningSection(query).then((res) => {
        if (res.code == 200) {
          this.$message.success("修改成功");
          this.getData();
        } else {
          this.$message.error(res.data);
        }
        this.setAuditScopeDialogVisible = false;
      });
    },
    // 课题管理员多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //删除课题管理员
    delSubjectUser() {
      if (this.multipleSelection.length <= 0) return;
      let data = [];
      data = this.multipleSelection.map((item) => {
        let arr = {
          id: item.id,
          roleId: item.roleId,
        };
        arr.roleId = arr.roleId.split(",");
        console.log(arr.roleId);
        arr.roleId.splice(arr.roleId.indexOf("5"), 1);
        console.log(arr.roleId);
        arr.roleId = arr.roleId.join(",");
        return arr;
      });
      this.updateRole(data, "del");
    },
    // 添加课题管理员
    addSubjectManager() {
      this.query = {
        realName: "",
        unitName: "",
        pageNumber: 1,
        pageSize: 10,
        type: 2,
        pageSorts: [{ asc: true, column: "" }],
      };
      this.getData(2);
    },
    //搜索
    searchUser() {
      this.getData(2);
    },
    // 返回
    toBack() {
      this.query = {
        realName: "",
        unitName: "",
        pageNumber: 1,
        pageSize: 10,
        type: 1,
        pageSorts: [{ asc: true, column: "" }],
      };
      this.getData();
    },

    // 用户多选
    userSelectionChange(val) {
      this.userMultipleSelection = val;
    },
    //添加课题管理员
    addSubjectUser() {
      if (this.userMultipleSelection.length <= 0) return;
      let data = [];
      data = this.userMultipleSelection.map((item) => {
        let arr = {
          id: item.id,
          roleId: item.roleId,
        };
				if (arr.roleId) {
					arr.roleId = arr.roleId.split(",");
				}else{
					arr.roleId = []
				}
        arr.roleId.push("5");
        arr.roleId = arr.roleId.join(",");
        return arr;
      });
      console.log(data);
      this.updateRole(data, "add");
    },
    // 修改角色id
    updateRole(query, type) {
      updateRole(query).then((res) => {
        if (res.code == 200) {
          if (type == "del") {
            this.$message.success("删除成功");
            this.getData();
          } else if (type == "add") {
            this.$message.success("添加成功");
            this.toBack();
          }
          this.multipleSelection = [];
          this.userMultipleSelection = [];
        } else {
          this.$message.error(res.data);
        }
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.query.pageNumber = val;
      this.getData();
    },
		// 用户列表分页导航
		handlePageChange2(val) {
		  this.query.pageNumber = val;
		  this.getData(2);
		},
  },
};
</script>

<style scoped lang="scss">
.btn-wrap {
  margin-top: 20px;
}
</style>
